import { sprout } from './nature/sprout';
import { petals } from './nature/petals';
import { cactus } from './nature/cactus';
import { planet } from './nature/planet';
import { shroom } from './nature/shroom';
import { leaf } from './nature/leaf';
import { acorn } from './nature/acorn';
import { drop } from './nature/drop';
import { cherry } from './nature/cherry';
import { flame } from './nature/flame';
import { tulip } from './nature/tulip';
import { pine } from './nature/pine';
import { puff } from './nature/puff';
import { volcano } from './nature/volcano';
import { pumpkin } from './nature/pumpkin';
import { carrot } from './nature/carrot';

/** Nature bodies, in picker order. */
export const NATURE_BODIES = {
  sprout,
  petals,
  cactus,
  planet,
  shroom,
  leaf,
  acorn,
  drop,
  cherry,
  flame,
  tulip,
  pine,
  puff,
  volcano,
  pumpkin,
  carrot,
};
